import React from 'react'
import { Field } from 'redux-form'
// import { DateFormatter } from 'common-controls/Core/index'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import DateTime from 'react-datetime'
import { Input } from 'reactstrap'
import { FAIcon } from './FAIcon'
import moment from 'moment'
import _ from 'common-tools/LodashHelper'

class DateRangeBoxPlainClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    timeFormat: pt.oneOfType([
      pt.string, pt.bool
    ]),
    dateFormat: pt.oneOfType([
      pt.string, pt.bool
    ]),
    closeOnSelect: pt.bool
  })

  static defaultProps = {
    timeFormat: false,
    dateFormat: true,
    closeOnSelect: true
  }

  onChange(position, newValue) {
    const { input: { onChange, value }, timeFormat } = this.props
    let newValues = _.clone(_.isArray(value) ? value : [])
    if (moment.isMoment(newValue)) {
      if (timeFormat) {
        newValues[position] = newValue.utc()
      } else {
        newValues[position] = newValue.startOf('day')
      }
    } else {
      newValues[position] = null
    }

    onChange(newValues)
  }

  renderStartInput(props, openCalendar, closeCalendar) {
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <Input placeholder='From' type='text' {...props} style={{ ...props.style, paddingLeft: '36px' }} />
        <span
          onClick={() => { openCalendar() }}
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#888',
            background: 'none',
            border: 'none',
            padding: 0,
            lineHeight: 1,
            zIndex: 1
          }}
        >
          <FAIcon name='calendar'></FAIcon>
        </span>
      </div>
    )
  }

  renderEndInput(props, openCalendar, closeCalendar) {
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <Input placeholder='To' type='text' {...props} style={{ ...props.style, paddingRight: '36px' }} />
        <span
          onClick={() => { openCalendar() }}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#888',
            background: 'none',
            border: 'none',
            padding: 0,
            lineHeight: 1,
            zIndex: 1
          }}
        >
          <FAIcon name='calendar'></FAIcon>
        </span>
      </div>
    )
  }

  render() {
    const { closeOnSelect, timeFormat, dateFormat, SessionAccount, ...rest } = this.props

    let roFormat = ''

    if (dateFormat === true & timeFormat === true) {
      roFormat = SessionAccount.DateFormat.DateAndTime
    } else if (dateFormat === true) {
      roFormat = SessionAccount.DateFormat.OnlyDate
    } else {
      roFormat = SessionAccount.DateFormat.OnlyTime
    }

    let df = dateFormat
    if (dateFormat === true) {
      df = SessionAccount.DateFormat.OnlyDate
    }
    let tf = timeFormat
    if (timeFormat === true) {
      tf = SessionAccount.DateFormat.OnlyTime
    }

    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, name, placeHolder, loading, readonly }) =>
          <div>
            {readonly
              ? <Input type='text' readOnly name={`staticrange0${name}`} id={`staticrange0${name}`}
              // value={DateFormatter.Format(roFormat, SessionAccount, value)}
              />
              : <DateTime
                timeFormat={tf} // means we want to show and collect time
                dateFormat={df}
                utc={!timeFormat} // if not collecting time, value should always be utc
                displayTimeZone={timeFormat ? SessionAccount.TimeZoneIdIANA : 'UTC'} // if collecting time, tell component the users timezone
                disabled={loading}
                placeholder='From'
                invalid={showError}
                name={`daterange0${name}`} id={`daterange0${name}`}
                onChange={this.onChange.bind(this, 0)} value={_.isArray(value) ? value[0] : null}
                renderInput={this.renderStartInput.bind(this)}
                closeOnSelect={closeOnSelect}
              />
            }
            <div style={{ marginBottom: '10px' }} />
            {readonly
              ? <Input type='text' readOnly name={`staticrange1${name}`} id={`staticrange1${name}`}
              // value={DateFormatter.Format(roFormat, SessionAccount, value)}
              />
              : <DateTime
                timeFormat={tf} // means we want to show and collect time
                dateFormat={df}
                utc={!timeFormat} // if not collecting time, value should always be utc
                displayTimeZone={timeFormat ? SessionAccount.TimeZoneIdIANA : 'UTC'} // if collecting time, tell component the users timezone
                disabled={loading}
                invalid={showError}
                name={`daterange1${name}`} id={`daterange1${name}`}
                onChange={this.onChange.bind(this, 1)} value={_.isArray(value) ? value[1] : null}
                renderInput={this.renderEndInput.bind(this)}
                closeOnSelect={closeOnSelect}
              />
            }
          </div>
        }
      </FieldLayoutBox>
    )
  }
}

const DateRangeBoxClass = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
  ])
)(DateRangeBoxPlainClass)

export const DateRangeBox = ({ parse, format, fieldType, ...rest }) => {
  return <Field parse={fieldType ? FieldValueParser(fieldType) : parse}
    format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest}
    component={DateRangeBoxClass} />
}
export default DateRangeBox
